import { initVideoListener, addToWishlist, removeFromWishlist, setFavorites, initComponent, renderPageInModal, showModalLogin } from "@api/utils_2020";
require("jquery-mask-plugin");

export default () => {
    const portobelloService = Util.service("WSPortobelloSite", true, {
        exceptionHandler: console.error,
        reflectSuccess: function (pbSiteService) {
            return pbSiteService;
        },
        reflectError: function () {
            console.error("Erro de conexão, verifique sua conexão com a internet.");
        },
    });

    const idUser = $('.pb-cartsales').attr('data-idUser');
    const userType = $('.pb-cartsales').attr('data-portobelloshopusertype');

    /** OPEN CART MODAL  */
    $('body').off('click', '.jsOpenProductModal').on('click', '.jsOpenProductModal', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".pb-myshop-product-add-modal").remove();
        var step = $(this).data('step');
        var type = $(this).data('type');
        var id = $(this).data('id');
        /* console.log(step); */
            UtilUi.loadTemplate("assets/components/pb-myshop-product-add-modal/pb-myshop-product-add-modal.tpl", function(dataContact, tpl) {
            var html = tpl.fetch({
                step: step,
                type: type,
                id: id
            });
            $('body').append(html);
            initComponent("pb-myshop-product-add-modal");
            $("#pb-myshop-product-add-modal").modal('show');
        });
        return false;
    });

    /** OPEN CART SECTION  */
   /*  $('body').off('click', '.jsOpenCart').on('click', '.jsOpenCart', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.pb-cartsales').toggle("slide", { direction: "right", easing: "swing" }, 200);
        $("body").addClass("noscroll");
        $("body").addClass("showModal");
    }); */

    /** CLOSE CART SECTION  */
/*     $('body').off('click', '.jsCloseCart').on('click', '.jsCloseCart', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.pb-cartsales').toggle("slide", { direction: "right", easing: "swing" }, 200);
        $("body").removeClass("noscroll");
        $("body").removeClass("showModal");
    });

    $('.pb-matte').off('click').on('click', function(){
        $('.jsCloseCart').trigger('click');
    }) */

    /** OPEN NEW CART FORM  */
   /*  $('body').off('click', '.jsAddCart').on('click', '.jsAddCart', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.search').hide();
        $('.btn-back').addClass('show');
        $('.jsAddCartContainer').fadeIn();        
        $('.jsCartContainer').hide();
        $('.jsEmptySearchMessage').hide();

    }); */

    /** CLOSE NEW CART FORM  */
    /* $('body').off('click', '.jsCancelAddCart').on('click', '.jsCancelAddCart', function (e) {
        e.preventDefault();
        e.stopPropagation();        
        $('.jsAddCartContainer').hide();
        $('.jsCartContainer').fadeIn();
        $('.jsCartAmbientsContainer').html('');
        $('.search').show();
        $('.btn-back').removeClass('show');
    }); */

    /** OPEN NEW AMBIENT FORM  */
    /* $('body').off('click', '.jsAddCartAmbient').on('click', '.jsAddCartAmbient', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let cartName = $(this).attr('data-cartName');
        let idCart = $(this).attr('data-idCart');

        var ambientsNames = [];
        let cartElement = $(`.pb-cartsales--single[data-idcart="${idCart}"]`).find(".jsAmbientCartItem"); 
        cartElement.each(function(){
            let name = $(this).find(".jsAmbientName").text().trim();
            ambientsNames = ambientsNames.concat(name);
        });
        console.log(ambientsNames);
        let optionsElement = $('.jsAddCartAmbientForm select[name="cartAmbient"]').find('option');
        optionsElement.each(function(){
            let optionValue = $(this).text().trim();
            if(ambientsNames.includes(optionValue)){
                $(this).hide();
                $(this).prop('selected', false);
            }else{
                $(this).show();
                $(this).attr('selected', true);
                $(this).prop('selected', true);
            }
        })

        $(`.jsAddCartAmbientForm input[name="cartName"]`).val(cartName);
        $(`.jsAddCartAmbientForm input[name="idCart"]`).val(idCart);
        $('.jsAddCartAmbientContainer').fadeIn();
        $('.jsCartContainer').hide();        
        $('.search').hide();
        $('.btn-back').addClass('show');
    }); */

    /** CLOSE NEW AMBIENT FORM  */
   /*  $('body').off('click', '.jsCancelAddCartAmbient').on('click', '.jsCancelAddCartAmbient', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.jsAddCartAmbientContainer').hide();
        $('.jsCartContainer').fadeIn();
        $('.jsCartAmbientsContainer').html('');
        $('.search').show();
        $('.btn-back').removeClass('show');
    });
 */
    /** INSERT CART AND ADD AMBIENT TO IT  */
    /* $('.jsAddCartForm').on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let cartName = $(this).find('input[name="cartName"]').val();
        let cartAmbient = $(this).find('select[name="cartAmbient"]').val();
        let cartNotes = $(this).find('textarea[name="extraNote"]').val();

        let cartNameElem = $(this).find('input[name="cartName"]');

        if(cartName == null || cartName == 'undefined' || cartName == ''){
            let errorMessage = `<span>Informe o nome do pré-orçamento</span>`;
            cartNameElem.parent('.form-group').append(errorMessage);
            return false;
        }else{
            cartNameElem.parent('.form-group').find('span').remove();
        }

        let submitButton = $(this).find('input[type="submit"]');
        submitButton.attr('disabled', true);
        submitButton.prop('disabled', true);
        submitButton.val('Adicionando...');

        var insertCartData = {
            "idUser": idUser,
            "name": cartName,
            "userType": userType,
            "extraNote": cartNotes
        };

        portobelloService.insertCart(insertCartData, {
            success: cart => {
                $('.jsAddCartContainer').hide();
                $('.jsCartContainer').fadeIn();
                $('.search').show();
                $('.btn-back').removeClass('show');
                cartNameElem.val('');
                if (!isNaN(cart)) {
                    $('.jsCartContainer').html('');
                    var insertCartAmbientData = {
                        "idCart": cart,
                        "idSalesForceAmbient": cartAmbient
                    };
                    portobelloService.insertCartAmbient(insertCartAmbientData, {
                        success: cartAmbient => {
                            var data = {
                                "idUser" : idUser,
                                "dateSent" : null
                            };
                            var options = {
                                "1" : "id DESC"
                            };
                            var fields = {
                                "0":"id",
                                "1":"name",
                                "2":"productAmount"
                            };
                            portobelloService.listCart(data, options, fields, false, {
                                success: cartsList => {
                                    var homePath = $('.pb-cartsales').attr('data-homepath');
                                    UtilUi.loadTemplate("assets/components/pb-cartsales--single/pb-cartsales--single.tpl", function (dataContact, tpl) {
                                        var html = tpl.fetch({
                                            carts: cartsList,
                                            homePath: homePath
                                        });
                                        $(".jsCartContainer").append(html);
                                        $('.search').show();
                                        $(`.pb-cartsales--single[data-idcart="${cart}"]`).find('.jsOpenCartAmbients').trigger('click');
                                    });

                                    submitButton.attr('disabled', false);
                                    submitButton.prop('disabled', false);
                                    submitButton.val('Adicionar pré-orçamento');
                                    
                                    if(cartsList.total > 4){
                                        $(".jsSearchCartContainer").show();
                                    }
                                }
                            })
                        }
                    })
                } else {
                    $('.jsCartContainer').append('Erro ao inserir cart');
                    submitButton.attr('disabled', false);
                    submitButton.prop('disabled', false);
                    submitButton.val('Adicionar pré-orçamento');
                }
            }
        })
        return false;
    }); */

    /** ADD AMBIENT TO SELECTED CART  */
    /* $('.jsAddCartAmbientForm').on('submit', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let submitButton = $(this).find('input[type="submit"]');

        submitButton.attr('disabled', true);
        submitButton.prop('disabled', true);

        submitButton.val('Adicionando...');

        let cartAmbient = $(this).find('select[name="cartAmbient"]').val();
        let idCart = $(this).find('input[name="idCart"]').val();

        var insertCartAmbientData = {
            "idCart": idCart,
            "idSalesForceAmbient": cartAmbient
        };

        portobelloService.insertCartAmbient(insertCartAmbientData, {
            success: cartAmbient => {
                var data = {
                    "idUser" : idUser,
                    "dateSent" : null
                };
                var options = {
                    "1" : "id DESC"
                };
                var fields = {
                    "0":"id",
                    "1":"name",
                    "2":"productAmount"
                };
                $('.search').show();
                $('.btn-back').removeClass('show');
                portobelloService.listCart(data, options, fields, false, {
                    success: cartsList => {
                        var homePath = $('.pb-cartsales').attr('data-homepath');
                        $(".jsAddCartAmbientContainer").hide();
                        $(".jsCartContainer").html('');
                        UtilUi.loadTemplate("assets/components/pb-cartsales--single/pb-cartsales--single.tpl", function (dataContact, tpl) {
                            var html = tpl.fetch({
                                carts: cartsList,
                                homePath: homePath
                            });
                            $(".jsCartContainer").append(html);
                            $(".jsCartContainer").fadeIn();
                            $('.search').show();
                            $(`.pb-cartsales--single[data-idcart="${idCart}"]`).find('.jsOpenCartAmbients').trigger('click');
                            submitButton.attr('disabled', false);
                            submitButton.prop('disabled', false);

                            submitButton.val('Adicionar pré-orçamento');
                        });
                    }
                })
            }
        })

        return false;
    }); */

    /** OPEN CART AMBIENTS TO ADD PRODUCT  */
  /*   $('body').off('click', '.jsOpenCartAmbients').on('click', '.jsOpenCartAmbients', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.jsEmptySearchMessage').hide();
        $('.jsCartAmbientsContainer').html(``);

        let selectedParentElement = $(this).parents('.pb-cartsales--single');
        let selectedCart = $(this).parents('.pb-cartsales--single').attr('data-idCart');
        let cartName = $(`.pb-cartsales--single[data-idCart="${selectedCart}"]`).find('.jsCartName').html();

        var data = {
            "idCart": selectedCart,
        };
        var options = {};
        var fields = {};

        portobelloService.listCartAmbient(data, options, fields, false, {
            success: cartAmbient => {
                if (cartAmbient.total > 0) {
                    var selectElement = `<ul class="list-group jsCartProductAmbient" style="display:none"></ul>`;
                    selectedParentElement.find('.jsCartAmbientsContainer').html(selectElement);
                    selectedParentElement.find('.jsCartAmbientsContainer').fadeIn();
                    selectedParentElement.find('.jsCartProductAmbient').append(`<p>Ambientes:</p>`);
                    selectedParentElement.find('.jsCartProductAmbient').fadeIn();

                    
                    cartAmbient.results.forEach(item => {
                        // console.log(item.CartProduct.id);
                        let deleteAmbientDisplay = ``;
                        // if(item.idSalesForceAmbient == "1"){
                        if(item.idSalesForceAmbient == "0"){
                            deleteAmbientDisplay = `style="display:none"`;
                        }
                        let itemElement = `<li class="jsAmbientCartItem" style="list-style:none" id="${item.idSalesForceAmbient}${item.idCart}" data-idsalesforceambient="${item.idSalesForceAmbient}" data-idcart="${item.idCart}">
                            <div class="card text-left p-3">
                                <div class="float-right">
                                    <a class="jsInsertQuantity" style="margin-right: 5px;" href="#">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="#5CA694" d="M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z"/></svg>
                                    </a>
                                    <a class="jsConfirmRemoveAmbient" href="#" ${deleteAmbientDisplay}>
                                        <svg id="trash" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 17.778 20">
                                            <path id="Caminho_2245" data-name="Caminho 2245" d="M11.629,21.207a.4.4,0,0,1-.441-.359l-.718-6.869a.4.4,0,0,1,.356-.444l.4-.042a.4.4,0,0,1,.441.359l.71,6.869a.4.4,0,0,1-.356.444Z" transform="translate(-4.459 -4.357)" fill="#969BA0"/>
                                            <path id="Caminho_2246" data-name="Caminho 2246" d="M16.084,21.164a.4.4,0,0,1-.356-.444l.718-6.869a.4.4,0,0,1,.441-.359l.4.042a.4.4,0,0,1,.356.444l-.718,6.875a.4.4,0,0,1-.441.359Z" transform="translate(-5.486 -4.358)" fill="#969BA0"/>
                                            <path id="Caminho_2247" data-name="Caminho 2247" d="M10.211,1a1.162,1.162,0,0,0-1.066.673L8.287,3.592H4.546A1.514,1.514,0,0,0,3,5.074V6.926A1.506,1.506,0,0,0,4.351,8.4L6.741,20.4A.766.766,0,0,0,7.5,21h9.522a.763.763,0,0,0,.764-.631L19.522,8.381a1.5,1.5,0,0,0,1.256-1.456V5.074a1.514,1.514,0,0,0-1.546-1.481H15.49l-.858-1.919A1.162,1.162,0,0,0,13.565,1Zm3.6,2.592-.3-.667a.778.778,0,0,0-.71-.444H10.975a.778.778,0,0,0-.71.444l-.3.667Zm4.111,5.139a.313.313,0,0,0-.321-.35L6.324,8.407a.312.312,0,0,0-.317.364l2,10.12a.8.8,0,0,0,.794.627h6.849a.8.8,0,0,0,.8-.667Zm.534-1.806a.758.758,0,0,0,.778-.741v-.37a.758.758,0,0,0-.778-.741H5.319a.758.758,0,0,0-.778.741v.37a.758.758,0,0,0,.778.741Z" transform="translate(-3 -1)" fill="#969BA0" fill-rule="evenodd"/>
                                        </svg>
                                    </a>                                        
                                </div>
                                <span class="jsAmbientName"> ${item.ambientName}</span>                                 
                            </div>
                        </li>`;
                        selectedParentElement.find('.jsCartProductAmbient').append(itemElement);
                        var data = {
                            "idCart": selectedCart,
                            "idSalesForceAmbient": item.idSalesForceAmbient,
                        };
                        var options = {};
                        var fields = {
                            "0": "id",
                            "1": "idCart",
                            "2": "sku",
                            "3": "productQuantity",
                            "4": "productName",
                            "5": "productUnity"
                        };

                        portobelloService.listCartProduct(data, options, fields, {
                            success: productAmbient => {
                                let newParent = $(`.jsAmbientCartItem#${item.idSalesForceAmbient}${item.idCart}`);
                                // newParent.append(`<p>Produtos:</p>`);
                                newParent.append(`<ul class="col-11 offset-1 list-group mb-2 mt-0"></ul>`);
                                productAmbient.results.forEach(item => {
                                    let unity = item.productUnity == "m2" || item.productUnity == "M2" ? "m<sup>2</sup>" : item.productUnity; 
                                    let skuProductElement = `<li class="list-group-item" id="${item.id}" data-sku="${item.sku}">
                                        ${item.sku} - ${item.productName} (${item.productQuantity} ${unity})                                   
                                        <a class="jsConfirmRemoveProduct float-right" href="#">
                                            <svg id="trash" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 17.778 20">
                                                <path id="Caminho_2245" data-name="Caminho 2245" d="M11.629,21.207a.4.4,0,0,1-.441-.359l-.718-6.869a.4.4,0,0,1,.356-.444l.4-.042a.4.4,0,0,1,.441.359l.71,6.869a.4.4,0,0,1-.356.444Z" transform="translate(-4.459 -4.357)" fill="#969BA0"/>
                                                <path id="Caminho_2246" data-name="Caminho 2246" d="M16.084,21.164a.4.4,0,0,1-.356-.444l.718-6.869a.4.4,0,0,1,.441-.359l.4.042a.4.4,0,0,1,.356.444l-.718,6.875a.4.4,0,0,1-.441.359Z" transform="translate(-5.486 -4.358)" fill="#969BA0"/>
                                                <path id="Caminho_2247" data-name="Caminho 2247" d="M10.211,1a1.162,1.162,0,0,0-1.066.673L8.287,3.592H4.546A1.514,1.514,0,0,0,3,5.074V6.926A1.506,1.506,0,0,0,4.351,8.4L6.741,20.4A.766.766,0,0,0,7.5,21h9.522a.763.763,0,0,0,.764-.631L19.522,8.381a1.5,1.5,0,0,0,1.256-1.456V5.074a1.514,1.514,0,0,0-1.546-1.481H15.49l-.858-1.919A1.162,1.162,0,0,0,13.565,1Zm3.6,2.592-.3-.667a.778.778,0,0,0-.71-.444H10.975a.778.778,0,0,0-.71.444l-.3.667Zm4.111,5.139a.313.313,0,0,0-.321-.35L6.324,8.407a.312.312,0,0,0-.317.364l2,10.12a.8.8,0,0,0,.794.627h6.849a.8.8,0,0,0,.8-.667Zm.534-1.806a.758.758,0,0,0,.778-.741v-.37a.758.758,0,0,0-.778-.741H5.319a.758.758,0,0,0-.778.741v.37a.758.758,0,0,0,.778.741Z" transform="translate(-3 -1)" fill="#969BA0" fill-rule="evenodd"/>
                                            </svg>
                                        </a>
                                        <!-- 
                                        <button class="btn btn-sm btn-outline-danger jsRemoveProduct" style="display:none">Remover</button>
                                        -->                                    
                                    </li>`;
                                    newParent.find('ul').append(skuProductElement);
                                });
                                setTimeout(() => {
                                    selectedParentElement.find('ul.jsCartProductAmbient').fadeIn();
                                }, 100);
                            }
                        });
                    });
                } else {
                    selectedParentElement.find('.jsCartAmbientsContainer').append('<p class="emptyAmbientMessage">Nenhum ambiente cadastrado no pré-orçamento!*</p>');
                    selectedParentElement.find('.jsCartAmbientsContainer').fadeIn();
                }
                let addAmbientToCartButton = `
                <div class="col-12 text-right">
                    <button class="btn btn-sm btn-outline-dark jsAddCartAmbient" data-idCart="${selectedCart}" data-cartName="${cartName}">
                        Adicionar novo ambiente ao pré-orçamento
                    </button>
                </div>`;

                let maxAmbients = $('.jsAddCartAmbientContainer select[name="cartAmbient"]').find('option.jsVal');
                let productAmbients = selectedParentElement.find('.jsCartProductAmbient li');
                
                if (maxAmbients.length == productAmbients.length) {
                    // there's no more ambients to add into this cart
                }else{
                    selectedParentElement.find('.jsCartAmbientsContainer').append(addAmbientToCartButton);
                }
            }
        })


    }); */

    /** DISPLAY CONFIRM PRODUCT BUTTON WHEN AMBIENT IS SELECTED  */
    /* $('body').off('click', '.jsCartProductAmbient').on('click', '.jsCartProductAmbient', function (e) {
        e.preventDefault();
        e.stopPropagation();
        console.log('mostrar botao de adicionar produto');
        return false;
        let selectVal = $(this).val();
        $(this).parent('.jsCartAmbientsContainer').find('.jsConfirmCartProduct').remove();

        if (typeof selectVal == 'undefined' || selectVal == '') {
            console.log("Selecione um ambiente para adicionar o produto");
            return false;
        }

        var confirmElement = `<button class="jsConfirmCartProduct">Adicionar produto ao pré-orçamento com ambiente</button>`;
        $(this).parent('.jsCartAmbientsContainer').append(confirmElement);

    }); */

    /** INSERT PRODUCT TO CART WHEN CONFIRMATION IS PRESSED  */
   /*  $('body').off('click', '.jsInsertQuantity').on('click', '.jsInsertQuantity', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let parentElement = $(this).parents('.jsCartAmbientsContainer');
        let idCart = $(this).parents('.pb-cartsales--single').attr('data-idCart');
        let idSalesForceAmbient = $(this).parents('li').attr('data-idsalesforceambient');
        let productSku = $('.pb-productsdetails-stock.product').children('div').children('div').attr('id');
        let productPrice = $('.jsPrice').attr('data-price');
        let productUnityType = $('.jsPrice').attr('data-unitytype');
        let promotionalPrice = $('.jsPromotionalPrice').attr('data-price');
        let ambientCartItemId = $(this).parents(".jsAmbientCartItem").attr('id');

        var modalData = {
            "cartProductId": null,
            "idCart": idCart,
            "idSalesForceAmbient": idSalesForceAmbient,
            "productSku": productSku,
            "productPrice": productPrice,
            "promotionalPrice": promotionalPrice,
            "ambientCartItemId": ambientCartItemId,
            "productUnityType": productUnityType,
            "quantity": null,
            "observation": null
        };

        $("#addQuantityModal").remove();
        
        UtilUi.loadTemplate("assets/components/pb-cartsales/pb-cartsales--modal-quantity.tpl", function(dataContact, tpl) {
            var html = tpl.fetch({
                cartProductData: modalData
            });
            $('body').append(html);
            // $(`.jsTypedQuantity`).mask("#.##0,00", {reverse: true, placeholder: "99,99",alias: 'numeric', allowMinus: false, digits: 2, });
            $(`.m2-mask`).mask("#.##0,00", {reverse: true, placeholder: "99,99",alias: 'numeric', allowMinus: false, digits: 2, });
            $(`.kg-mask`).mask("#.##0,000", {reverse: true, placeholder: "99,99",alias: 'numeric', allowMinus: false, digits: 3, });
            $(`.pc-mask`).mask("0000", {reverse: true, placeholder: "9999",alias: 'numeric', allowMinus: false, });
            $(`.un-mask`).mask("0000", {reverse: true, placeholder: "9999",alias: 'numeric', allowMinus: false, });
            $(`.jg-mask`).mask("0000", {reverse: true, placeholder: "9999",alias: 'numeric', allowMinus: false, });
            $('#addQuantityModal').modal('show');
        });
        return false;
    }); */

    /** INSERT PRODUCT TO CART WHEN CONFIRMATION IS PRESSED  */
   /*  $('body').off('click', '#jsConfirmCartProduct').on('click', '#jsConfirmCartProduct', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(".jsQuantityError").remove();

        let ambientCartItemId = $(this).data("ambientcartitemid");
        let idCart = $(this).data("idcart");
        let idSalesForceAmbient = $(this).data("idsalesforceambient");
        let productSku = $(this).data("productsku");
        let productPrice = $(this).data("productprice");
        let promotionalPrice = $(this).data("promotionalprice");
        let productUnityType = $(this).data("productunitytype");
        let productObservation = $(".jsProductObservation").val() != "" ? $(".jsProductObservation").val() : null;
        switch (productUnityType) {
            case "m2":
            case "kg":
                var rawQuantity = $('.jsTypedQuantity').val().replace(",", ".");
                var typedQuantity = parseFloat( rawQuantity );
                break;
            case "un":
            case "jg":
            case "pc":
                var typedQuantity = parseInt( $('.jsTypedQuantity').val() );
                break;
        }
        
        let parentElement = $(`#${ambientCartItemId}`).parents('.jsCartAmbientsContainer');

        if (typedQuantity == "" || typedQuantity == null || isNaN(typedQuantity)) {
            let errorElement = `<span class="text-danger mt-1 jsQuantityError">Informe corretamente a quantidade desejada</span>`;
           $(".jsTypedQuantity").parent().append(errorElement);
           return false;
        }
        
        
        $('#addQuantityModal').modal("hide");

        if (productPrice == "") {
            productPrice = null;
        }

        if (promotionalPrice == "") {
            promotionalPrice = null;
        }

        if (typedQuantity == "" || typedQuantity == null) {
            typedQuantity = null;
        }

        var insertObject = {
            "idCart": idCart,
            "idSalesForceAmbient": idSalesForceAmbient,
            "sku": productSku,
            "price": productPrice,
            "promotionalPrice": promotionalPrice,
            "typedQuantity": typedQuantity,
            "productObservation": productObservation
        }

        portobelloService.insertCartProduct(insertObject, {
            success: cartProduct => {
                parentElement.html('');
                if (cartProduct == true) {
                    parentElement.append(`<p class="jsReturnMessage">Produto inserido com sucesso!</p>`);
                    let cartContainer = parentElement.parents('.pb-cartsales--single');
                    let productAmountElem= cartContainer.find('p.total');
                    let splitProductAmount = productAmountElem.text().split(" ");
                    let productAmount = parseInt(splitProductAmount[0]) + 1;
                    productAmountElem.html(`${productAmount} Produtos`);
                    $(`.pb-cartsales--single[data-idcart="${idCart}"]`).find('.jsOpenCartAmbients').trigger('click');
                    setTimeout(() => {
                        $('.jsReturnMessage').remove();
                    }, 1500);
                } else if (cartProduct == 'duplicated') {
                    parentElement.append(`<p class="jsReturnMessage">Produto já inserido neste ambiente do no pré-orçamento!</p>`);
                } else {
                    parentElement.append(`<p class="jsReturnMessage">Erro ao adicionar o produto neste ambiente!</p>`);
                }
                $(".pb-matte").trigger('click');
                UtilUi.alert({title:'Produto adicionado!', message: 'O produto foi inserido no pré-orçamento selecionado..'}, 'success');
            }
        })
        return false;
    }); */

    /** CONFIRM PRODUCT REMOVAL  */
  /*   $('body').off('click', '.jsConfirmRemoveProduct').on('click', '.jsConfirmRemoveProduct', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let productSku = $(this).parents('li').attr('data-Sku');
        let productId = $(this).parents('li').attr('id');

        $("#deleteModal").remove();
        
        UtilUi.loadTemplate("assets/components/pb-cartsales/pb-cartsales--modal-delete.tpl", function(dataContact, tpl) {
            var html = tpl.fetch({
                productSku: productSku,
                productId: productId,
                urlImageServer: urlImageServer,
                urlHome: urlhome
            });
            $('body').append(html);
            $("#deleteModal .modal-body p").html(`Remover produto`)
            $("#deleteModal .modal-title").html(`Deseja remover o produto do pré-orçamento?`)
            let deleteButton = `
            <svg id="trash" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 17.778 20">
                <path id="Caminho_2245" data-name="Caminho 2245" d="M11.629,21.207a.4.4,0,0,1-.441-.359l-.718-6.869a.4.4,0,0,1,.356-.444l.4-.042a.4.4,0,0,1,.441.359l.71,6.869a.4.4,0,0,1-.356.444Z" transform="translate(-4.459 -4.357)" fill="#969BA0"/>
                <path id="Caminho_2246" data-name="Caminho 2246" d="M16.084,21.164a.4.4,0,0,1-.356-.444l.718-6.869a.4.4,0,0,1,.441-.359l.4.042a.4.4,0,0,1,.356.444l-.718,6.875a.4.4,0,0,1-.441.359Z" transform="translate(-5.486 -4.358)" fill="#969BA0"/>
                <path id="Caminho_2247" data-name="Caminho 2247" d="M10.211,1a1.162,1.162,0,0,0-1.066.673L8.287,3.592H4.546A1.514,1.514,0,0,0,3,5.074V6.926A1.506,1.506,0,0,0,4.351,8.4L6.741,20.4A.766.766,0,0,0,7.5,21h9.522a.763.763,0,0,0,.764-.631L19.522,8.381a1.5,1.5,0,0,0,1.256-1.456V5.074a1.514,1.514,0,0,0-1.546-1.481H15.49l-.858-1.919A1.162,1.162,0,0,0,13.565,1Zm3.6,2.592-.3-.667a.778.778,0,0,0-.71-.444H10.975a.778.778,0,0,0-.71.444l-.3.667Zm4.111,5.139a.313.313,0,0,0-.321-.35L6.324,8.407a.312.312,0,0,0-.317.364l2,10.12a.8.8,0,0,0,.794.627h6.849a.8.8,0,0,0,.8-.667Zm.534-1.806a.758.758,0,0,0,.778-.741v-.37a.758.758,0,0,0-.778-.741H5.319a.758.758,0,0,0-.778.741v.37a.758.758,0,0,0,.778.741Z" transform="translate(-3 -1)" fill="#969BA0" fill-rule="evenodd"/>
            </svg>
            <strong>Sim, excluir</strong>
            `;
            $("#deleteModal #confirmDelete").html(deleteButton);
            $("#deleteModal #confirmDelete").removeClass(`jsRemoveCartAmbient`);
            $("#deleteModal #confirmDelete").removeClass(`jsRemoveCartProduct`);
            $("#deleteModal #confirmDelete").addClass(`jsRemoveProduct`);
            $("#deleteModal #confirmDelete").attr(`data-productSku`, productSku);
            $("#deleteModal #confirmDelete").attr(`data-productId`, productId);
            $('#deleteModal').modal('show');
        });
    }); */


    /** REMOVE PRODUCT FROM AMBIENT AND CART  */
   /*  $('body').off('click', '.jsRemoveProduct').on('click', '.jsRemoveProduct', function (e) {
        e.preventDefault();
        e.stopPropagation();
        // let productSku = $(this).parents('li').attr('data-Sku');
        // let productId = $(this).parents('li').attr('id');
        let productSku = $(this).attr('data-productSku');
        let productId = $(this).attr('data-productId');

        portobelloService.deleteCartProduct(productId, {
            success: deletedProduct => {
                let productAmountElem= $(`#${productId}`).parents('.pb-cartsales--single').find('p.total');
                let splitProductAmount = productAmountElem.text().split(" ");
                let productAmount = parseInt(splitProductAmount[0]) - 1;
                productAmountElem.html(`${productAmount} Produtos`);
                
                $(`#${productId}`).hide();
                $(`#${productId}`).remove();
                $('#deleteModal').modal('hide');
            }
        });
    }); */

    /** CONFIRM AMBIENT REMOVAL  */
   /*  $('body').off('click', '.jsConfirmRemoveAmbient').on('click', '.jsConfirmRemoveAmbient', function (e) {
        e.preventDefault();
        e.stopPropagation();
        let cartId = $(this).parents('li.jsAmbientCartItem').attr('data-idcart');
        let ambientId = $(this).parents('li.jsAmbientCartItem').attr('data-idsalesforceambient');
        $("#deleteModal").remove();
        
        UtilUi.loadTemplate("assets/components/pb-cartsales/pb-cartsales--modal-delete.tpl", function(dataContact, tpl) {
            var html = tpl.fetch({
                idCart: cartId,
                idSalesForceAmbient: ambientId,
                urlImageServer: urlImageServer,
                urlHome: urlhome
            });
            $('body').append(html);
            $("#deleteModal .modal-body p").html(`Remover ambiente`)
            $("#deleteModal .modal-title").html(`Deseja remover o ambiente e seus produtos do pré-orçamento?`)
            let deleteButton = `
            <svg id="trash" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 17.778 20">
                <path id="Caminho_2245" data-name="Caminho 2245" d="M11.629,21.207a.4.4,0,0,1-.441-.359l-.718-6.869a.4.4,0,0,1,.356-.444l.4-.042a.4.4,0,0,1,.441.359l.71,6.869a.4.4,0,0,1-.356.444Z" transform="translate(-4.459 -4.357)" fill="#969BA0"/>
                <path id="Caminho_2246" data-name="Caminho 2246" d="M16.084,21.164a.4.4,0,0,1-.356-.444l.718-6.869a.4.4,0,0,1,.441-.359l.4.042a.4.4,0,0,1,.356.444l-.718,6.875a.4.4,0,0,1-.441.359Z" transform="translate(-5.486 -4.358)" fill="#969BA0"/>
                <path id="Caminho_2247" data-name="Caminho 2247" d="M10.211,1a1.162,1.162,0,0,0-1.066.673L8.287,3.592H4.546A1.514,1.514,0,0,0,3,5.074V6.926A1.506,1.506,0,0,0,4.351,8.4L6.741,20.4A.766.766,0,0,0,7.5,21h9.522a.763.763,0,0,0,.764-.631L19.522,8.381a1.5,1.5,0,0,0,1.256-1.456V5.074a1.514,1.514,0,0,0-1.546-1.481H15.49l-.858-1.919A1.162,1.162,0,0,0,13.565,1Zm3.6,2.592-.3-.667a.778.778,0,0,0-.71-.444H10.975a.778.778,0,0,0-.71.444l-.3.667Zm4.111,5.139a.313.313,0,0,0-.321-.35L6.324,8.407a.312.312,0,0,0-.317.364l2,10.12a.8.8,0,0,0,.794.627h6.849a.8.8,0,0,0,.8-.667Zm.534-1.806a.758.758,0,0,0,.778-.741v-.37a.758.758,0,0,0-.778-.741H5.319a.758.758,0,0,0-.778.741v.37a.758.758,0,0,0,.778.741Z" transform="translate(-3 -1)" fill="#969BA0" fill-rule="evenodd"/>
            </svg>
            <strong>Sim, excluir</strong>
            `;
            $("#deleteModal #confirmDelete").html(deleteButton);
            $("#deleteModal #confirmDelete").removeClass(`jsRemoveCartAmbient`);
            $("#deleteModal #confirmDelete").removeClass(`jsRemoveCartProduct`);
            $("#deleteModal #confirmDelete").addClass(`jsRemoveCartAmbient`);
            $("#deleteModal #confirmDelete").attr(`data-idCart`, cartId);
            $("#deleteModal #confirmDelete").attr(`data-idSalesForceAmbient`, ambientId);
            $('#deleteModal').modal('show');
        })


        
    }); */

    /** REMOVE PRODUCT FROM AMBIENT AND CART  */
   /*  $('body').off('click', '.jsRemoveCartAmbient').on('click', '.jsRemoveCartAmbient', function (e) {
        e.preventDefault();
        e.stopPropagation();

        let idCart = $(this).attr('data-idCart');
        let idSalesForceAmbient = $(this).attr('data-idSalesForceAmbient');
        let ambientElem = `${idSalesForceAmbient}${idCart}`;

        portobelloService.deleteCartAmbients(idCart, idSalesForceAmbient, {
            success: deleteAmbient => {
                let productAmountElem= $(`#${ambientElem}`).parents('.pb-cartsales--single').find('p.total');
                let splitProductAmount = productAmountElem.text().split(" ");

                let ambientProducts = $(`#${ambientElem}`).find('li').length;

                let productAmount = parseInt(splitProductAmount[0]) - parseInt(ambientProducts);
                productAmountElem.html(`${productAmount} Produtos`);
                
                // adicionar elemento se zerados
                if ($(`#${ambientElem}`).parents('.jsCartProductAmbient').find('.jsAmbientCartItem').length == 0)
                {
                    $(`#${ambientElem}`).parents('.jsCartProductAmbient').remove();
                    $(`#${ambientElem}`).parents('.jsCartAmbientsContainer').append('<p class="emptyAmbientMessage">Nenhum ambiente cadastrado no pré-orçamento!*</p>');
                } else {
                    $(`#${ambientElem}`).fadeOut('fast', function() {
                        $(this).remove();
                    });
                }
                
                
                $('#deleteModal').modal('hide');
            }
        });
    }); */


    /** SEARCH LIST  */
    /* $('input[name="searchCart"]').off('keyup').on('keyup', function (event) {
        var query = $(this).val();
        if (query) {
            var search = $(`.pb-cartsales--single[data-title*='${query}' i]`);
            if (search.length > 0) {
                $('.jsEmptySearchMessage').hide();
                $(".pb-cartsales--single").hide();
                search.each(function (index, element) {
                    $(element).show();
                });
            }
            else {
                $(".pb-cartsales--single").hide();
                $('.jsEmptySearchMessage').show();
            }
        }
        else {
            $('.jsEmptySearchMessage').hide();
            $(".pb-cartsales--single").show();
        }
    }); */

};